import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "ionic-angular";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../../app/auth/auth.service";
import { ConfigurationService } from "../configuration/configuration.service";
import { SpinnerService } from "../spinnerService/spinnerService";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class HospiceDataService {
  patChartId: string;
  dataUrl: string;
  jasperUrl: string;
  resourceUri: string;
  reportExecutionUri: string;
  report: string;
  headers: HttpHeaders;

  constructor(
    private authSvc: AuthService,
    public http: HttpClient,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public stateData: StateManagementService,
    private spinnerService: SpinnerService,
    private config: ConfigurationService
  ) {
    this.headers = new HttpHeaders().set("Content-Type", "application/json");

    /*
        name of the report
        ending in .pdf is important to get a response of type application/pdf
        */
    this.report = "Hospice_Services_Utilization.pdf";
    this.dataUrl = config.getConfig().reportsUrl;
  }

  ionViewCanEnter() {
    return this.authSvc.authenticated();
  }

  public downloadReport(data) {
    let startDate = moment(data["startDate"]).format("YYYY-MM-DD");
    let orgId = data["orgId"];
    let endDate = moment(data["endDate"]).format("YYYY-MM-DD");
    let fileName = `Hospice_Services_Utilization_${startDate}_${endDate}.pdf`;

    try {
      let body =
        "pOrgID=697190&pStartDate=" +
        startDate +
        "&pEndDate=" +
        endDate +
        "&format=pdf";
      let url =
        this.dataUrl +
        "/Hospice_Services_Utilization.pdf/Hospice_Services_Utilization/" +
        body;
      this.spinnerService.start("Downloading...");
      this.http.get(url).subscribe(
        (data) => {
          var base64 = "data:application/pdf;base64," + data["body"];
          this.download(base64, "ReportAssessment-" + fileName);
          this.presentSuccessToast("File downloaded successfully");
          this.spinnerService.stop();
        },
        (err) => {
          this.presentErrorToast(err, "Failed to download report");
          this.spinnerService.stop();
        }
      );
    } catch (error) {
      this.presentErrorToast(error, "Failed to download report");
      this.spinnerService.stop();
    }
  }

  download(base64Data, filename) {
    var print = document.createElement("a");
    print.href = base64Data;
    print.setAttribute("download", filename);
    print.target = "_blank";
    var event = document.createEvent("MouseEvents");
    event.initEvent("click", false, true);
    print.dispatchEvent(event);
    return false;
  }

  // TODO: Handle more gracefully
  protected handleException(exception: any) {
    let message = `${exception.status} : ${exception.statusText}\n${
      exception.body ? exception.body.error : ""
    }`;
    console.log(exception);
    console.log(message);
    return Observable.throw(exception);
  }
  //wrong way to do this but need to get it working
  /**Error and Spinner Functions*/

  presentErrorToast(err: HttpErrorResponse, message: string) {
    if (err && (err as any).code === "REFRESH_TOKEN_FAILED") {
      return;
    }
    message += " ";
    if (err.error instanceof Error) {
      message += "Client error.";
    } else {
      message += " ";
      if (err.status == 401) {
        message += "User not authorized.";
      } else if (err.status >= 500) {
        message += "Server error.";
      } else {
        message += "Communication error.";
      }
    }

    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "error",
    });
    toast.present();
  }

  presentSuccessToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "success",
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/hospice-data-service/hospice-data-service.ts